/*
 * @Description: 
 * @Author: 长老
 * @Date: 2019-09-10 10:33:47
 * @LastEditTime: 2020-03-18 14:06:18
 * @LastEditors: 陆伟
 */
import axios from 'axios'
import { Toast } from 'mint-ui'

const Http = (function () {
  const instance = axios.create({
    baseURL: `//${globalConfig.ysappItemBasePath}/yunjiysapp/app`,
    withCredentials: true
  })
  instance.interceptors.response.use(res => res.data, (error) => {
    //Toast('网络错误')
    return error
  })
  return instance
}())
const Http1 = (function () {
  const instance = axios.create({
    baseURL: `//${globalConfig.searchLinkPath}/indexsearchweb`,
    withCredentials: true
  })
  instance.interceptors.response.use(res => res.data, (error) => {
  //  Toast('网络错误')
    return error
  })
  return instance
}())
const Http2 = (function () {
  const instance = axios.create({
    baseURL: `//${globalConfig.itemBasePath}`,
    withCredentials: true
  })
  instance.interceptors.response.use(res => res.data, (error) => {
  //  Toast('网络错误')
    return error
  })
  return instance
}())


/**
 * 获取搜索热词
 */
export const querySearchPage = (params = {}) => Http1.get('/indexsearch/querySearchPage.json', { params })
/**
 * 查询搜索框类型
 */
export const querySearchType = (params = {}) => Http.get('/categoryguide/querySearchType.json', { params })
/**
 * 查询左侧类目名字
 */
export const queryCategoryName = (params = {}) => Http.get('/categoryguide/queryCategoryName.json', { params })
/**
 * 查询banner和类目数据
 */
// export const queryCategoryData = (params = {}) => Http.get('/categoryguide/queryCategoryData.json', { params })
export const queryCategoryData = (params = {}) => Http.get('/categoryguide/queryCategoryDataForPersonalRecommend.json', { params })
/**
 * 品牌分类专区列表
 */
export const getBrandSaleZoneList = (params = {}, appCont) => Http.post('/categoryguide/getBrandSaleZoneListV2.json' + `?appCont=${appCont}`, params)
/**
* 商品列表功能
*/
export const queryCategoryList = (params = {}) => Http.post('/app/item/listItemByCategoryLevel.json', params)
/**
 * 获取一级类目列表(类目下面有品牌墙品牌的类目)
 */
export const queryBrandMenu = (params = {}) => Http2.get('/yunjiitemapp/app/category/getBrandHouseCategoryList.json', { params })
/**
 * 品牌墙获取所有品牌（列表）
 */
export const queryBrandList = (params = {}) => Http2.get('/yunjiitemapp/app/brandHouse/getAllBrandList.json', { params })


/**
 * 判断钻石会员(小程序)
 * https://user.yunjiglobal.com/yunjiuserapp/userapp/memberType.json?ticket=ticket%7Cminiprograme_154648013_13acedb33c0f451f7b211d5eb8cc100f&appCont=7
 * @param {*} param memberType = 1 钻石会员
 */
 export function checkIsDiamondMember(params) {
  return axios({
    url: `//${globalConfig.userPath}/yunjiuserapp/userapp/memberType.json`, 
    type: 'GET', 
    params, 
    dataType: 'json', 
    xhrFields: { withCredentials: true }, 
    crossDomain: true 
  })
}
